module.exports = __webpack_public_path__ + "img/cintes-personalitzadess.62531fd4.jpg";